import { prepareZXingModule } from 'zxing-wasm';

export const disableScrollAndMove = () => {
  const touchMoveListener = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  document.addEventListener('touchmove', touchMoveListener, { passive: false });
  const bodyOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  return () => {
    // undo
    document.removeEventListener('touchmove', touchMoveListener);
    document.body.style.overflow = bodyOverflow;
  };
};

export function CancelError(message) {
  this.name = 'CancelError';
  this.message = message || 'Scan Code operation canceled';
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, CancelError);
  } else {
    this.stack = new Error().stack;
  }
}

CancelError.prototype = Object.create(Error.prototype);
CancelError.prototype.constructor = CancelError;

let zxingReady = false;

export async function initZxingWasm() {
  if (zxingReady) return;
  const wasmUrl = `${window.origin + window.ICP_PUBLIC_PATH}wasm/zxing_full.wasm`;
  const wasmResponse = await fetch(wasmUrl);
  const wasmBytes = await wasmResponse.arrayBuffer();
  const wasmFileUrl = URL.createObjectURL(new Blob([wasmBytes], { type: 'application/wasm' }));

  await prepareZXingModule({
    overrides: {
      locateFile: (path, prefix) => {
        if (path.endsWith('.wasm')) {
          return wasmFileUrl;
        }
        return prefix + path;
      },
      postRun: [
        () => {
          URL.revokeObjectURL(wasmFileUrl);
          zxingReady = true;
        },
      ],
    },
  });
}
